import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

const Specification = ({ specifications }) => {
    const selectedSpecification = useSelector((state) => state.specification);
    
    let specArr;
    if (
        selectedSpecification?.specifications &&
        selectedSpecification.specifications.length > 0
    ) {
        specArr = JSON.parse(selectedSpecification.specifications);
    } else {
        specArr = JSON.parse(specifications);
    }
    if (!specArr) specArr = false;

    const setSelected = (event) => {
        event.currentTarget.classList.toggle('expanded');
    };
    return (
        specArr &&
        specArr.length > 0 && (
            <div className="small-12 large-12 columns product-about">
                <div className="product-about__accordion">
                    {specArr.map((spec, index) => (
                        <div
                            className="product-about__heading-container"
                            key={index}
                            onClick={(e) => setSelected(e)}
                        >
                            <div className="product-about__heading">
                                <h2 className="product-about__title">
                                    {spec.heading}
                                </h2>
                                <div className="product-about__icon"></div>
                            </div>
                            <div className="product-about__content">
                                <div className=" product-about__documents">
                                    {spec.fieldValues &&
                                        spec.fieldValues.length > 0 &&
                                        spec.fieldValues.map(
                                            (speces, indexInner) =>
                                                isNaN(speces?.value) ? (
                                                    <div
                                                        key={indexInner}
                                                        className="product-about__specifications"
                                                    >
                                                        <div
                                                            className="product-about__specifications-item"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    speces.value,
                                                            }}
                                                        ></div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="product-about__specifications product-about__specifications--range product-about__specifications--full-width"
                                                        key={indexInner}
                                                    >
                                                        <div className="product-about__specifications-item-wrap">
                                                            <h3 className="product-about__specifications-item product-about__specifications-item--label">
                                                                {
                                                                    speces.translation
                                                                }
                                                            </h3>
                                                            <span>
                                                                {speces.value}/7
                                                            </span>
                                                        </div>
                                                        <div
                                                            className={`product-about__specifications-item-range product-about__specifications-item-range--${speces.value}`}
                                                        ></div>
                                                    </div>
                                                )
                                        )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    );
};

export default Specification;
